export function formatCurrency(
  value: number | string | null | undefined
): string {
  if (value === null || value === undefined || isNaN(Number(value))) return '-'

  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(Number(value))
}
